<template>
  <v-dialog
    v-model="open"
    persistent
    max-width="768px"
    content-class="tw-rounded-3xl"
    scrollable
  >
    <v-form
      ref="form"
      v-model="valid"
      :disabled="form_disabled_state"
      lazy-validation
      enctype="multipart/form-data"
      @submit.prevent="update"
    >
      <v-card class="tw-rounded-3xl tw-border-0">
        <ModalHeader @close-modal="closeModal">Imagen</ModalHeader>
        <v-divider />
        <v-card-text class="tw-p-0" style="max-height: 700px">
          <v-responsive class="tw-py-0">
            <v-container class="tw-bg-gray-50 tw-p-0" fluid>
              <v-row class="mb-5 tw-m-0">
                <v-col cols="12" md="12" class="mx-auto tw-p-0">
                  <v-card
                    class="mx-auto tw-divide-y tw-divide-gray-200 tw-rounded-none tw-bg-gray-50 tw-py-2 tw-px-6 tw-shadow-none"
                  >
                    <v-container class="pa-5">
                      <div class="tw-px-4 tw-py-2">
                        <div
                          class="tw-items-center sm:tw-flex sm:tw-justify-between"
                        >
                          <div class="tw-flex tw-flex-col">
                            <h3
                              class="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900"
                            >
                              {{ $t('admin.app.desktop_image') }}
                            </h3>
                            <p
                              id="privacy-option-1-description"
                              class="tw-mb-0 tw-text-sm tw-text-gray-500"
                            >
                              {{ $t('admin.app.select_image') }}
                            </p>
                          </div>
                          <div
                            class="tw-mt-5 sm:tw-mt-0 sm:tw-ml-6 tw-flex tw-flex-shrink-0 tw-items-center tw-space-x-2"
                          >
                            <v-text-field
                              v-model.number="mountedSection.data.image_width_desktop"
                              type="number"
                              min="1"
                              outlined
                              rounded
                              dense
                              hide-details
                              :label="$t('app.image_width')"
                              class="tw-w-32"
                            />
                            <v-text-field
                              v-model.number="mountedSection.data.image_height_desktop"
                              type="number"
                              min="1"
                              outlined
                              rounded
                              dense
                              hide-details
                              :label="$t('app.image_height')"
                              class="tw-w-32"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="tw-mt-3 tw-grid tw-grid-cols-1 tw-gap-1">
                        <DropzoneOverlayPreview
                          v-model="mountedSection.data.image_desktop"
                          :width="desktopDimentions[0]"
                          :height="desktopDimentions[1]"
                          :bypass="'ratio-check'"
                          media-group="registries_landings"
                        />
                      </div>
                    </v-container>
                    <v-container class="pa-5">
                      <div class="tw-px-4 tw-py-2">
                        <div
                          class="tw-items-center sm:tw-flex sm:tw-justify-between"
                        >
                          <div class="tw-flex tw-flex-col">
                            <h3
                              class="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900"
                            >
                              {{ $t('admin.app.mobile_image') }}
                            </h3>
                            <p
                              id="privacy-option-1-description"
                              class="tw-mb-0 tw-text-sm tw-text-gray-500"
                            >
                              {{ $t('admin.app.select_image') }}
                            </p>
                          </div>
                          <div
                            class="tw-mt-5 sm:tw-mt-0 sm:tw-ml-6 tw-flex tw-flex-shrink-0 tw-items-center tw-space-x-2"
                          >
                            <v-text-field
                              v-model.number="mountedSection.data.image_width_mobile"
                              type="number"
                              min="1"
                              outlined
                              rounded
                              dense
                              hide-details
                              :label="$t('app.image_width')"
                              class="tw-w-32"
                            />
                            <v-text-field
                              v-model.number="mountedSection.data.image_height_mobile"
                              type="number"
                              min="1"
                              outlined
                              rounded
                              dense
                              hide-details
                              :label="$t('app.image_height')"
                              class="tw-w-32"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="tw-mt-3 tw-grid tw-grid-cols-1 tw-gap-1">
                        <DropzoneOverlayPreview
                          v-model="mountedSection.data.image_mobile"
                          :width="mobileDimentions[0]"
                          :height="mobileDimentions[1]"
                          :bypass="'ratio-check'"
                          media-group="registries_landings"
                        />
                      </div>
                    </v-container>
                  </v-card>
                  <v-card
                    class="mx-auto tw-divide-y tw-divide-gray-200 tw-rounded-3xl tw-bg-transparent tw-shadow-none"
                  >
                    <v-container class="pa-5">
                      <!-- Active Call to action -->
                      <ToggleGroup v-model="mountedSection.data.has_cta">
                        <template #title>{{ $t('app.enable_cta') }}</template>
                        <template #description>
                          {{ $t('app.cta_description_slider') }}
                        </template>
                        <template #extras>
                          <div
                            class="
                              tw-grid tw-grid-cols-1 tw-gap-y-4 tw-gap-x-4
                              sm:tw-grid-cols-6
                            "
                          >
                            <div class="sm:tw-col-span-3">
                              <v-text-field
                                v-model="mountedSection.data.cta_label"
                                outlined
                                rounded
                                :label="$t('admin.app.name')"
                              />
                            </div>
                            <div class="sm:tw-col-span-3">
                              <v-select
                                v-model="mountedSection.data.cta_link_type"
                                :items="types_link"
                                validate-on-blur
                                label="Type"
                                outlined
                                rounded
                              />
                            </div>
                            <div class="sm:tw-col-span-6">
                              <v-text-field
                                v-if="mountedSection.data.cta_link_type == 'external'"
                                v-model="mountedSection.data.cta_link"
                                outlined
                                rounded
                                label="Link"
                              />
                              <v-select
                                v-if="mountedSection.data.cta_link_type == 'internal'"
                                v-model="mountedSection.data.cta_link"
                                :items="internalPages"
                                validate-on-blur
                                label="Type"
                                outlined
                                rounded
                              />
                            </div>
                          </div>
                        </template>
                      </ToggleGroup>
                      <!-- Active Call to action type btn -->
                      <ToggleGroup v-model="mountedSection.data.is_btn_cta">
                        <template #title>{{ $t('app.enable_cta_btn') }}</template>
                        <template #description>
                          {{ $t('app.cta_description_slider_btn') }}
                        </template>
                      </ToggleGroup>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>

              <transition name="fade-transition" mode="out-in">
                <v-row v-if="errorAlert">
                  <v-col cols="12">
                    <v-alert
                      v-model="errorAlert"
                      dismissible
                      color="red"
                      border="left"
                      elevation="2"
                      colored-border
                      icon="error"
                      transition="fade-transition"
                    >
                      {{ errorMsg }}</v-alert
                    >
                  </v-col>
                </v-row>
              </transition>
            </v-container>
          </v-responsive>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            rounded
            :disabled="form_loading"
            class="tw-px-8 tw-normal-case focus:tw-outline-none focus:tw-ring focus:tw-ring-white"
            @click="closeModal"
          >
            {{ $t('app.cancel') }}</v-btn
          >
          <v-btn
            color="primary darken-1"
            rounded
            type="submit"
            :loading="form_loading"
            class="text--white text--lighten-4 tw-px-8 tw-normal-case focus:tw-outline-none focus:tw-ring focus:tw-ring-primary-300"
          >
            {{ $t('app.save') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ModalHeader from '@/components/ModalHeader'
import DropzoneOverlayPreview from '@/components/DropzoneOverlayPreview.vue'
import ToggleGroup from '../FormInputs/ToggleGroup.vue'
import { BannerTypeKeys } from '@/enums/SectionTypeKeys'
import { rules } from '@/utils/rules'
import { greatestCommonDivisor } from '@/utils/greatestCommonDivisor'
import { ImageRatio, internalPages } from '@/models/RegistryLanding'

export default {
  components: {
    ModalHeader,
    DropzoneOverlayPreview,
    ToggleGroup,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    section: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    rules,
    internalPages,
    BannerTypeKeys,
    errorAlert: '',
    errorMsg: '',
    isLoading: false,
    form_loading: false,
    form_disabled_state: false,
    valid: true,
    mountedSection: {},
    isLoadingRooms: false,
  }),
  computed: {
    // tuple [W,H]
    /**
     * @returns {array}
     */
    desktopDimentions() {
      return [
        this.mountedSection.data.image_width_desktop,
        this.mountedSection.data.image_height_desktop,
      ]
    },
    // tuple [W,H]
    /**
     * @returns {array}
     */
    mobileDimentions() {
      return [
        this.mountedSection.data.image_width_mobile,
        this.mountedSection.data.image_height_mobile,
      ]
    },
    open: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    types_link() {
      return [
        { text: `Internal`, value: 'internal' },
        { text: `External`, value: 'external' },
      ]
    },
  },
  created() {
    this.mountedSection = JSON.parse(JSON.stringify(this.section))
    this.mountedSection.data = { ...ImageRatio(), ...this.mountedSection.data }
  },
  methods: {
    closeModal() {
      this.open = false
    },
    // Las clases tw-aspect-w-*/tw-aspect-h-* solo llegan hasta 16, asi que
    // reducimos proporcionalmente cualquier medida libre que exceda ese limite.
    clampRatio([x, y], max = 16) {
      const largest = Math.max(x, y)
      if (largest <= max) {
        return [x, y]
      }
      const scale = max / largest
      return [
        Math.max(1, Math.round(x * scale)),
        Math.max(1, Math.round(y * scale)),
      ]
    },
    update() {
      this.errorAlert = false
      if (!this.$refs.form.validate()) {
        return
      }
      const [ratio_desktop_x, ratio_desktop_y] = this.clampRatio(
        greatestCommonDivisor(
          this.desktopDimentions[0],
          this.desktopDimentions[1],
        ),
      )
      const [ratio_mobile_x, ratio_mobile_y] = this.clampRatio(
        greatestCommonDivisor(
          this.mobileDimentions[0],
          this.mobileDimentions[1],
        ),
      )
      this.mountedSection.data = {
        ...this.mountedSection.data,
        ratio_desktop_x,
        ratio_desktop_y,
        ratio_mobile_x,
        ratio_mobile_y,
      }
      this.$emit('updated-section', this.mountedSection)
      this.open = false
    },
  },
}
</script>

<style></style>
